import { render } from "./AvatarSvg.vue?vue&type=template&id=012a72fc&bindings={}"
import script from "./AvatarSvg.vue?vue&type=script&lang=ts"
export * from "./AvatarSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script